import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { AuthProvider } from './src/auth';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

// Global error handler for debugging blank screen
window.onerror = function(message, source, lineno, colno, error) {
  const errorDiv = document.createElement('div');
  errorDiv.style.position = 'fixed';
  errorDiv.style.top = '0';
  errorDiv.style.left = '0';
  errorDiv.style.width = '100%';
  errorDiv.style.background = '#991b1b';
  errorDiv.style.color = 'white';
  errorDiv.style.padding = '20px';
  errorDiv.style.fontFamily = 'monospace';
  errorDiv.style.zIndex = '9999';
  errorDiv.innerHTML = `
    <h1 style="margin:0 0 10px 0; font-size: 18px;">Startup Error</h1>
    <pre style="margin:0; white-space: pre-wrap;">${message}\n${error?.stack || ''}</pre>
  `;
  document.body.appendChild(errorDiv);
};

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <AuthProvider>
      <App />
    </AuthProvider>
  </React.StrictMode>
);
